const barbaBeforeLeaveFunctions = (data) => {
		
	/***************************************************************
		Remove about leaders modal from body
	***************************************************************/

	const $modals = $('body > .modal-transplant');
	const $csfmodal = $('body > .csf-modal');
	
	if ($modals.length) {
		$modals.remove();
	}
	
	if ($csfmodal.length) {
		$csfmodal.remove();
	}
	
	const $dataVideo = $('body > .data-video');
	
	if ($dataVideo.length) {
		$dataVideo.remove();
	}

}

export {
	barbaBeforeLeaveFunctions
};
